import { Container } from "@shared-components/Container/Container";
import { Heading } from "@shared-components/Heading/Heading";
import { LayoutContainer } from "@shared-components/LayoutContainer/LayoutContainer";
import { Box, Text as ReactText } from "theme-ui";
import React from "react";
import { generateCbKey } from "../../../shared/utils/generate-cbKey";
import {
  headingStylesCollection,
  headingStylesWhiteCollection,
  textStylesCollection,
  textStylesWhiteCollection,
} from "../../missionHybridSlider/MultiSliderModule/styles";
import { THEMES_MAP } from "../../../carlsberg-headless/themes-map";
import { VideoLink } from "./VideoLink";

export type MultiSliderMediaProps = {
  format: string;
  src: string;
  link: string;
  videoId: string | undefined;
  noSound?: boolean;
};

export type MultiSliderModuleProps = {
  themes: string[];
  heading: string;
  subHeading: string;
  medias: MultiSliderMediaProps[];
  columns?: number;
};

const VideoLinkModule: React.FC<MultiSliderModuleProps> = ({
  heading,
  subHeading,
  medias,
  themes,
  columns = 2,
}) => {
  let headingStyle;
  if (themes.includes(THEMES_MAP.layout_bg.layout_bg_white)) {
    headingStyle = headingStylesCollection;
  } else if (themes.includes(THEMES_MAP.layout_bg.layout_bg_lightergray)) {
    headingStyle = headingStylesCollection;
  } else {
    headingStyle = headingStylesWhiteCollection;
  }

  let subHeadingStyle;
  if (themes.includes(THEMES_MAP.layout_bg.layout_bg_white)) {
    subHeadingStyle = textStylesCollection;
  } else if (themes.includes(THEMES_MAP.layout_bg.layout_bg_lightergray)) {
    subHeadingStyle = textStylesCollection;
  } else {
    subHeadingStyle = textStylesWhiteCollection;
  }

  let theme;
  if (themes.includes(THEMES_MAP.layout_bg.layout_bg_white)) {
    theme = "light";
  } else if (themes.includes(THEMES_MAP.layout_bg.layout_bg_lightergray)) {
    theme = "light";
  } else {
    theme = "dark";
  }

  if (!medias) {
    return null;
  }

  return (
    <LayoutContainer themes={themes}>
      <Container>
        <Heading as={"h2"} sx={headingStyle}>
          {heading}
        </Heading>
        <ReactText as={"h3"} sx={subHeadingStyle}>
          {subHeading}
        </ReactText>
      </Container>
      <Container>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            flexWrap: "wrap",
          }}
        >
          {medias.map((media) => (
            <VideoLink
              media={media}
              theme={theme}
              key={`video-${media.videoId}`}
              cbKey={generateCbKey()}
              videoTitle={heading}
              stylingprop={{
                width: [
                  "full",
                  "full",
                  columns === 2
                    ? "calc(50% - 20px)"
                    : `calc(${100 / columns}% - 20px)`,
                ],
                margin: "10px",
              }}
            />
          ))}
        </Box>
      </Container>
    </LayoutContainer>
  );
};

export { VideoLinkModule };
